/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */
export enum TrainDirection {
  NONE = 0,
  EAST = 1,
  WEST = 2
}

/**
 *
 * @class TrainClass
 *
 * @brief the category of trains.  All trains must have a train class.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2019
 *
 */
export class TrainClass {

  /** @var _id unique id fo this train class */
  public   _id: number         = -1;

  /** @var _name the normal name for this train */
  public _name: string         = '';

  /** @var _dir travel direction */
  public  _dir: TrainDirection = TrainDirection.NONE;

  /** @brief standard constructor */
  constructor(id: number, name: string, dir: boolean) {

    this._id   = id;
    this._name = name;

    if (dir) {

      this._dir = TrainDirection.WEST;

    } else {

      this._dir = TrainDirection.EAST;
    }
  }

  /** @brief convert track type to a string */
  public static typeToString(dir: TrainDirection): string {

    switch (dir) {
      case TrainDirection.EAST: return 'E';
      case TrainDirection.WEST: return 'W';
      case TrainDirection.NONE: return 'N';
    }

    return '';
  }

  /** @brief convert track string to a type */
  public static dirFromString(dir: string): TrainDirection {

    const tmp: string = dir.toLowerCase().trim();

    if ((tmp === 'e') || (tmp === 'false') || (tmp === '0') || (tmp === 'east')) {

      return TrainDirection.EAST;

    } else if ((tmp === 'w') || (tmp === 'true') || (tmp === '1') || (tmp === 'west')) {

      return TrainDirection.WEST;

    }

    return TrainDirection.NONE;
  }

}
